import React from 'react';

export interface CardProps {
  variant?: 'default' | 'elevated' | 'outlined';
  className?: string;
  children: React.ReactNode;
}

export interface CardHeaderProps {
  className?: string;
  children: React.ReactNode;
}

export interface CardBodyProps {
  className?: string;
  children: React.ReactNode;
}

export interface CardFooterProps {
  className?: string;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  variant = 'default',
  className = '',
  children,
}) => {
  const baseClasses = 'rounded-lg bg-surface transition-all duration-200';

  const variantClasses = {
    default: 'border border-border-light shadow-sm',
    elevated: 'border border-border-light shadow-md hover:shadow-lg',
    outlined: 'border-2 border-border-medium shadow-none',
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;

  return (
    <div className={combinedClasses}>
      {children}
    </div>
  );
};

const CardHeader: React.FC<CardHeaderProps> = ({
  className = '',
  children,
}) => {
  return (
    <div className={`px-4 sm:px-6 py-3 sm:py-4 border-b border-border-light flex items-center justify-between ${className}`}>
      {children}
    </div>
  );
};

const CardBody: React.FC<CardBodyProps> = ({
  className = '',
  children,
}) => {
  return (
    <div className={`px-4 sm:px-6 py-4 sm:py-6 ${className}`}>
      {children}
    </div>
  );
};

const CardFooter: React.FC<CardFooterProps> = ({
  className = '',
  children,
}) => {
  return (
    <div className={`px-4 sm:px-6 py-3 sm:py-4 border-t border-border-light bg-background-secondary ${className}`}>
      {children}
    </div>
  );
};

export { CardHeader, CardBody, CardFooter };
export default Card;

